import createReducer from '../createReducer';

const initialState = {
    videos: [],
};

const reducer = createReducer('management', initialState);

export default reducer;
